import { useEffect, useState } from "react";
import { StyledDocumentSettings } from "./DocumentSettings.style"
import { useParams } from "react-router-dom";
import { DocumentSettingsEditSchema, DocumentSettings as DocumentSettingsModel } from "../../../../../models/document-settings";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Checkbox, FormControlLabel, MenuItem, Select, TextField } from "@mui/material";
import { toast } from "react-toastify";
import { useErrorBoundary } from "react-error-boundary";
import { handleErrorWithBoundary } from "@shared/lib/errors"
import { checkInputValue } from "@shared/lib/utils";
import ReturnButton from "@shared/ui/navigation/ReturnButton";
import { useEditDocumentSettingsMutation, useGetDocumentsSettingsQuery } from "../../../api/documentsSettings.api";
// import { DevTool } from "@hookform/devtools";


function DocumentSettings() {

    const { showBoundary } = useErrorBoundary();

    const { data: documentsSettings } = useGetDocumentsSettingsQuery();
    const [ saveDocumentSettings, {isLoading: isSaving}] = useEditDocumentSettingsMutation();
    
    const [settings, setSettings] = useState<DocumentSettingsModel>();

    const settingsForm = useForm<DocumentSettingsModel>({
        resolver: zodResolver(DocumentSettingsEditSchema),
        defaultValues: settings
    });

    const { id } = useParams();

    useEffect(() => {
        if(documentsSettings){
            console.log("documents settings:", documentsSettings);
            const settings = setDocumentSettings(documentsSettings, Number(id));
            settingsForm.reset(settings);
        }
    }, [documentsSettings]);



    //find and set the settings of the current document type
    function setDocumentSettings(documentsSettings: DocumentSettingsModel[] | undefined, documentSettingsId: number | undefined): DocumentSettingsModel | undefined {

        if (!documentsSettings || !documentSettingsId) {
            return undefined;
        }

        const documentSettings = documentsSettings.find(documentsSetting => documentsSetting.id === documentSettingsId);
        setSettings(documentSettings);

        return documentSettings;
    }

    const saveSettings = () => {
        settingsForm.handleSubmit(onSubmitDocumentSettings)();
    }


    const onSubmitDocumentSettings: SubmitHandler<DocumentSettingsModel> = async (data) => {

        try {
            await saveDocumentSettings(data);
            toast.success("ההגדרות נשמרו");
        } catch (error) {
            handleErrorWithBoundary(error, showBoundary);;
        }
    }


    return (
        <StyledDocumentSettings>
            {settings && <>
                <div className="title">
                    {`הגדרות מסמך ${settings?.name ?? ""}`}
                </div>
                <div className="settings">
                    <div className="row">
                        <Controller
                            control={settingsForm.control}
                            name="display_customer"

                            render={({ field: { onChange, value } }) => (
                                <FormControlLabel control={<Checkbox onChange={onChange} checked={!!value} />} label="הצגת לקוח" />
                            )}
                        />
                    </div>
                    <div className="row">
                        <Controller
                            control={settingsForm.control}
                            name="display_car"

                            render={({ field: { onChange, value } }) => (
                                <FormControlLabel control={<Checkbox onChange={onChange} checked={!!value} />} label="הצגת רכב" />
                            )}
                        />
                    </div>
                    <div className="row">
                        <Controller
                            control={settingsForm.control}
                            name="display_works"

                            render={({ field: { onChange, value } }) => (
                                <FormControlLabel control={<Checkbox onChange={onChange} checked={!!value} />} label="הצגת עבודות" />
                            )}
                        />
                    </div>
                    <div className="row">
                        <Controller
                            control={settingsForm.control}
                            name="display_items"

                            render={({ field: { onChange, value } }) => (
                                <FormControlLabel control={<Checkbox onChange={onChange} checked={!!value} />} label="הצגת פריטים" />
                            )}
                        />
                    </div>
                    <div className="row">
                        <Controller
                            control={settingsForm.control}
                            name="display_payments"

                            render={({ field: { onChange, value } }) => (
                                <FormControlLabel control={<Checkbox onChange={onChange} checked={!!value} />} label="הצגת תשלום" />
                            )}
                        />
                    </div>


                    <table>
                        <tbody>
                            <tr>
                                <td>שם</td>
                                <td>
                                    <Controller
                                        control={settingsForm.control}
                                        name="name"
                                        render={({ field: { onChange, value } }) => (
                                            <TextField
                                                onChange={onChange} // send value to hook form
                                                value={checkInputValue(value)}
                                                size="small"
                                            />
                                        )}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>שם מקוצר</td>
                                <td>
                                    <Controller
                                        control={settingsForm.control}
                                        name="short_name"
                                        render={({ field: { onChange, value } }) => (
                                            <TextField
                                                onChange={onChange} // send value to hook form
                                                value={checkInputValue(value)}
                                                size="small"
                                            />
                                        )}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>עיגול אגורות</td>
                                <td>
                                    <Controller
                                        control={settingsForm.control}
                                        name="circle"

                                        render={({ field: { onChange, value } }) => (
                                            <Select
                                                sx={{ minWidth: 150 }}
                                                onChange={(e) => onChange(!!e.target.value)}
                                                value={checkInputValue(value)}
                                                size="small"
                                            >

                                                <MenuItem value={0}>לא</MenuItem>
                                                <MenuItem value={1}>כן</MenuItem>

                                            </Select>
                                        )}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>מסמך חשבונאי</td>
                                <td>
                                    <Controller
                                        control={settingsForm.control}
                                        name="accounting"

                                        render={({ field: { onChange, value } }) => (
                                            <Select
                                                sx={{ minWidth: 150 }}
                                                onChange={(e) => onChange(!!e.target.value)}
                                                value={checkInputValue(value)}
                                                size="small"
                                            >

                                                <MenuItem value={0}>לא</MenuItem>
                                                <MenuItem value={1}>כן</MenuItem>

                                            </Select>
                                        )}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="buttons">
                    <Button variant='contained' onClick={saveSettings} disabled={isSaving}>שמירה</Button>
                    <ReturnButton/>
                </div>
                {/* <DevTool control={settingsForm.control} /> */}
            </>}


        </StyledDocumentSettings>
    )
}

export default DocumentSettings